import React from 'react';
import { Box } from '@mui/material';

import { v2Colors } from '../design/theme';

export default function FreeGiftBadge({ sx }) {
  return (
    <Box
      component="span"
      sx={{
        ml: 1,
        px: 0.85,
        py: 0.25,
        borderRadius: 1,
        fontSize: '0.65rem',
        fontWeight: 800,
        color: v2Colors.white,
        bgcolor: v2Colors.success,
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
        verticalAlign: 'middle',
        display: 'inline-block',
        lineHeight: 1.2,
        animation: 'v2FreeGiftFlash 1.2s ease-in-out infinite',
        '@keyframes v2FreeGiftFlash': {
          '0%, 100%': {
            opacity: 1,
            boxShadow: '0 0 0 0 rgba(58, 90, 64, 0.55)',
            transform: 'scale(1)',
          },
          '50%': {
            opacity: 0.72,
            boxShadow: '0 0 10px 3px rgba(58, 90, 64, 0.45)',
            transform: 'scale(1.04)',
          },
        },
        ...sx,
      }}
    >
      Free gift
    </Box>
  );
}
